(ns ui.view.card.event
  (:require
   [re-frame.core :as rf]
   [potpuri.core :as p]
   [ui.cofx.response :as response-cofx]
   [frontend.subscription :as ws-subscription]
   [ui.view.card.model :as model]
   [ui.view.card.activities.event :as activities-event]
   [oops.core :as oops]))

(defn toggle-full-screen-event-db-handler
  "expects rf/trim-v interceptor"
  [db [{:keys [card-state-path] :as _ctx}]]
  (model/toggle-full-screen db card-state-path))

(defn entity-list->latest-entities-by-id
  [entity-list]
  (->> entity-list
       (group-by :db/id)
       (map (fn [[entity-id same-entities]]
              (let [latest-entity (->> same-entities
                                       (sort-by :common/updated-on)
                                       (last))]
                [entity-id latest-entity])))
       (into {})))

(defn card-ws-subscription-update-event-fx-handler
  "Expects rf/trim-v interceptor"
  [{:keys [db stale-response?]}
   [{:keys [card-state-path] :as _ctx}
    {:keys [entities] :as _update-msg}]]
  (when-not stale-response?
    (let [latest-entities-by-id (entity-list->latest-entities-by-id entities)
          new-db (-> db
                     (model/merge-entities card-state-path latest-entities-by-id))]
      {:db new-db})))

(defn card-ws-subscription-error-event-fx-handler
  "use rf/trim-v"
  [_cofx [_ctx error-msg]]
  ;; TODO
  (js/console.log "CARD WEBSOCKET ERROR" error-msg))

(def ws-sub-keys
  {:card.type/property-list :card/property-list
   :card.type/entity-associations :card/associations

   ;; TODO: Fix these with real subscriptions
   :card.type/counterparty-diligence-progress  :card/property-list
   :card.type/counterparty-diligence-docs      :card/property-list
   :card.type/counterparty-diligence-screening :card/property-list})

(defn close-card-ws-subscription-callback-event-fx-handler
  "use rf/trim-v"
  [_cofx [_ctx _msg]]
  ;; TODO handle callback?
  )

(defn open-card-ws-sub-fx
  [{:keys [card entity-id card-state-path synthetic-timestamp] :as ctx}]
  (let [card-type (:card/type card)]
    [[::ws-subscription/open {:key (model/->ws-subscription-key card-state-path)
                              :type (get ws-sub-keys card-type)
                              :opts {:card card
                                     :entity-id entity-id
                                     :synthetic-timestamp synthetic-timestamp}
                              :on-update-event [::card-ws-subscription-update ctx]
                              :on-error-event [::card-ws-subscription-error ctx]
                              :close-previous-subscription-if-exists? true}]]))

(defmulti after-fetch-card-data-success-fx
  (fn [{:keys [card] :as _ctx}]
    (:card/type card)))

(defmethod after-fetch-card-data-success-fx :default
  [_ctx]
  nil)

(defn fetch-card-data-failure-event-fx-handler
  "Expects that rf/trim-v interceptor is used when registering the event-fx"
  [{:keys [db stale-response?]}
   [{:keys [card-state-path] :as _ctx} _resp]]
  ;; TODO handle errors better
  (when-not stale-response?
    (let [new-db (-> db
                     (assoc-in (model/loading-error-full-path card-state-path) true))]
      {:db new-db})))

;; TODO: Implement the stale-response flag
(defn fetch-card-data-success-event-fx-handler
  "Expects that rf/trim-v interceptor is used when registering the event-fx"
  [{:keys [db stale-response?]}
   [{:keys [card card-state-path reset-entities? subscribe-to-realtime-changes?] :as ctx} resp]]
  (when-not stale-response?
    (let [resp-body (:body resp)
          entities (-> resp-body
                       :data
                       :entities)
          synthetic-timestamp (:synthetic-timestamp resp-body)
          card-type (:card/type card)
          entities-by-id (p/index-by :db/id entities)
          new-db (cond-> db
                   true (assoc-in (model/initial-data-loaded-full-path card-state-path) true)
                   reset-entities? (model/reset-entities card-state-path entities-by-id)
                   (not reset-entities?) (model/merge-entities card-state-path entities-by-id))

          fx (concat
              (after-fetch-card-data-success-fx ctx)

              (when (and subscribe-to-realtime-changes?
                         (contains? ws-sub-keys card-type))
                (open-card-ws-sub-fx (assoc ctx
                                            :synthetic-timestamp
                                            synthetic-timestamp))))]
      (merge
       {:db new-db}
       (when (seq fx)
         {:fx (vec fx)})))))

(defn fetch-card-data-event-fx-handler
  [{:keys [db]}
   [{:keys [entity-id card card-state-path
            on-success on-failure signal]
     :as ctx}]]
  (let [on-success (if (vector? on-success)
                     on-success
                     [::fetch-card-data-success ctx])
        on-failure (if (vector? on-failure)
                     on-failure
                     [::fetch-card-data-failure ctx])
        card-type (:card/type card)
        api-params (case card-type
                     :card.type/property-list
                     {:id :get-entity
                      :params {:entity-id entity-id
                               :card card}}

                     :card.type/survey-processes
                     {:id :survey-processes
                      :params {:entity-id entity-id
                               :card card}}

                     :card.type/counterparty-diligence-responder
                     {:id :get-counterparty-diligence-data
                      :params {:entity-id entity-id}}

                     :card.type/counterparty-diligence-progress
                     {:id :get-counterparty-diligence-data
                      :params {:entity-id entity-id
                               :card {:card/config
                                      {:rows [{:cells [{:field :counterparty-diligence/processes}]}]}}}}

                     :card.type/counterparty-diligence-docs
                     {:id :get-counterparty-diligence-data
                      :params {:entity-id entity-id}}

                     :card.type/counterparty-diligence-screening
                     {:id :get-counterparty-diligence-screening-data
                      :params {:entity-id entity-id}}

                     :card.type/counterparty-diligence-answers
                     {:id :get-counterparty-diligence-data
                      :params {:entity-id entity-id}}

                     :card.type/attachments
                     {:id     :get-entity-attachments
                      :params {:entity-id entity-id
                               :card card}}

                     :card.type/associations
                     {:id :get-entity-associations
                      :params {:entity-id entity-id
                               :card card}}

                     :card.type/activities
                     {:id :get-entity-activities
                      :params {:entity-id entity-id
                               :card card}}

                     :card.type/fees
                     {:id :get-entity-fees
                      :params {:entity-id entity-id
                               :card card}}

                     :card.type/risks
                     {:id :get-entity-risks
                      :params {:entity-id entity-id
                               :card card}}

                     :card.type/tasks
                     {:id :get-entity-tasks
                      :params {:entity-id entity-id
                               :card card}}

                     :card.type/value-creations
                     {:id :get-entity-value-creations
                      :params {:entity-id entity-id
                               :card card}}

                     :card.type/decisions
                     {:id :get-entity-decisions
                      :params {:entity-id entity-id
                               :card card}}

                     nil)]
    (when api-params
      {:db (assoc-in db (model/loading-error-full-path card-state-path) false)
       :fetch {:uri "/card/query"
               :method :post
               :body api-params
               :signal signal
               :on-success on-success
               :on-failure on-failure}})))

(defn create-fetch-card-data-event
  [{:keys [card] :as ctx}]
  (let [card-type (:card/type card)]
    (case card-type
      :card.type/activities
      [::activities-event/fetch-card-data ctx]

      [::fetch-card-data ctx])))

(defn card-cleanup-fx
  [{:keys [card card-state-path] :as ctx}]
  (let [card-type (:card/type card)]
    (cond
      (contains? ws-sub-keys card-type)
      [[::ws-subscription/close {:key (model/->ws-subscription-key card-state-path)
                                 :callback-event [::close-card-ws-subscription-callback ctx]}]]

      (= card-type :card.type/activities)
      [[:dispatch [::activities-event/cleanup ctx]]]

      :else
      nil)))

(rf/reg-event-db
 ::toggle-full-screen
 [rf/trim-v]
 toggle-full-screen-event-db-handler)

(rf/reg-event-fx
 ::fetch-card-data
 [rf/trim-v]
 fetch-card-data-event-fx-handler)

(rf/reg-event-fx
 ::fetch-card-data-success
 [rf/trim-v
  response-cofx/stale-response?]
 fetch-card-data-success-event-fx-handler)

(rf/reg-event-fx
 ::fetch-card-data-failure
 [rf/trim-v
  response-cofx/stale-response?]
 fetch-card-data-failure-event-fx-handler)

(rf/reg-event-fx
 ::card-ws-subscription-update
 [rf/trim-v
  response-cofx/stale-response?]
 card-ws-subscription-update-event-fx-handler)

(rf/reg-event-fx
 ::card-ws-subscription-error
 [rf/trim-v]
 card-ws-subscription-error-event-fx-handler)

(rf/reg-event-fx
 ::close-card-ws-subscription-callback
 [rf/trim-v
  response-cofx/stale-response?]
 close-card-ws-subscription-callback-event-fx-handler)

(rf/reg-event-fx
 ::close-subscriptions
 [rf/trim-v]
 (fn [_ [ctx]]
   (when-let [fx (card-cleanup-fx ctx)]
     {:fx fx})))

(rf/reg-event-fx
 ::clear-state
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path]}]]
   {:db (p/dissoc-in db card-state-path)}))

(rf/reg-event-fx
 ::clear-state-and-close-subscriptions
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as ctx}]]
   {:db (p/dissoc-in db card-state-path)
    :fx (card-cleanup-fx ctx)}))

;; TODO: Maybe move into cofx util ns
(rf/reg-cofx
 ::now-ms
 (fn [coeffects _]
   (assoc coeffects :now-ms (oops/ocall js/Date "now"))))

(rf/reg-event-fx
 ::close-entity-peek
 [rf/trim-v]
 (fn [{:keys [db]} [{:keys [card-state-path] :as _ctx}]]
   {:db (p/dissoc-in db (model/entity-peek-full-path card-state-path))}))

(rf/reg-event-fx
 ::open-entity-peek-or-close-if-already-open
 [rf/trim-v (rf/inject-cofx ::now-ms)]
 (fn [{:keys [db now-ms]} [{:keys [card-state-path] :as _ctx} peek-entity-id]]
   (let [prev-peek-entity-id (get-in db (model/entity-peek-entity-id-full-path card-state-path))
         same-entity? (= prev-peek-entity-id peek-entity-id)
         prev-open? (get-in db (model/entity-peek-open-full-path card-state-path))
         opened-at (get-in db (model/entity-peek-opened-at-full-path card-state-path))
         debounce? (and prev-open? same-entity? (< (- now-ms opened-at) 700))]
     (when-not debounce?
       (if same-entity?
         {:db (p/dissoc-in db (model/entity-peek-full-path card-state-path))}
         {:db (-> db
                  (assoc-in (model/entity-peek-open-full-path card-state-path) true)
                  (assoc-in (model/entity-peek-entity-id-full-path card-state-path) peek-entity-id)
                  (assoc-in (model/entity-peek-opened-at-full-path card-state-path) now-ms))})))))
